<template>
  
  <div class="show" v-if="showInfo">
     <div class="header">
        <div class="headerbox">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
          <div class="back">
              <a class="light" href="/InqMember">继续查询</a>
              <a href="/">返回页面</a>
          </div>
      
        </div>
    
      </div>
      <div class="result">
        <h2>证书查询结果页</h2>
        <div>根据全国职业信用评价网入库标准及规定，您的信息已入库，入库编号是 {{  showInfo.code  }}</div>
      </div>
    <div class="box">
      <!-- <div class="logo">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
        </div> -->
      <div class="content">
        <div class="typecontent">
          <h2>
            个人信息
          </h2>
          <span @click="download()" style="color:#2E8EEB;"  v-if="$route.query.comeinbysy!='1'" >下载电子证书</span>
        </div>
        <div class="headerinfo">
         
          <div class="compytitle">
            <img :src="`${IP_TEST}/uploads/xlsfile/usepic/${showInfo.picsrc}`" :alt="showInfo.name">
            <div class="info">
              <h3>
                {{ showInfo.name }}
              </h3>
              <p>
              所在地：{{ showInfo.country }}
              </p>
              <p>
               所属行业：{{ showInfo.industry }}
              </p>
              <p>
                <i class="el-icon-location-information"></i>{{ showInfo.address }}
              </p>
            </div>
            
          </div>
        </div>
        <div v-if="!showInfo.honoraryTitle" class="codeinfo">
          <img src="/static/img/huiayun.png" alt="">
          <span>会员编号：{{ showInfo.code }}</span>
        </div>
        <div v-else class="codeinfo" style="height: 115px;line-height: 55px;">
          <img src="/static/img/huiayun.png" alt="">
          <span style="margin-right:30px;">职业名称：{{ showInfo.honoraryTitle }}</span>
          <br/>  
          <span style="margin-right:30px;">职业级别：{{ showInfo.level }}</span>
          <br/> 
          <img src="/static/img/huiayun.png" alt="">
          <span>编号：{{ showInfo.code }}</span>
        </div>
        <div class="detailInfo">
          <div class="perinfo" style="margin-top: 6.533vw">个人简历</div>
          <table>
            <!-- <tr>
              <th colspan="2">个人简历</th>
            </tr> -->
            <tr>
              <td colspan="2" v-html="showInfo.description" ></td>
            </tr>
            <tr>
              <td style="width: 100px;">
                会员有效期
              </td>
              <td>
                {{ formatExcelData(showInfo.certdate) }}至{{ formatExcelData(showInfo.valieddate) }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
export default {
  name: "ShowQy",
  data() {
    return {
      IP_TEST
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    download() {
      this.$axios
        .get(`${IP_TEST}/uploads/证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`, {
          responseType: "blob", //重要
        })
        .then((response) => {
          if ("msSaveOrOpenBlob" in window.navigator) {
            //兼容ie浏览器下载报传递给系统调用的数据区域太小.
            var data = response;
            var blob = new Blob([data], { type: "application/vnd.ms-excel" });
            window.navigator.msSaveOrOpenBlob(blob, `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`);
            return;
          } else {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS&&!this.isWeixinBrowser()) {
              var jpeg = new Blob([response], { type: "image/jpeg" });
              const url = window.URL.createObjectURL(jpeg);
              const link = document.createElement("a");
              let fname = `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`;
              link.href = url;
              link.setAttribute("download", fname);
              link.download = fname;
              document.body.appendChild(link);
              link.click();
              return;
            }
            else if(isiOS&&this.isWeixinBrowser())
            {
              var winHeight = $(window).height();
              $(".weixin-tip").css("height",winHeight);
              $(".weixin-tip").show();
              return;
            }
            window.open(
              `${IP_TEST}/zhcpw/loadimgs?imgpath=证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`,
              "_blank"
            );
          }
        });
    },
    isWeixinBrowser() {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
        ? true
        : false;
    },
    isQQBrowser() {
      return /qq/.test(navigator.userAgent.toLowerCase()) ? true : false;
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
  }
  }
};
</script>
<style scoped>
.show{
  position: relative;
  width:100vw;
  min-height: 204vw;
  background-image: url(/static/img/img/beijign.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left bottom;
    padding-bottom: 71px;
}
.show .box{
  /* width: 94vw; */
  margin: auto;
  position: relative;
  top:2.4vw;
}
.logo{
  width: 90vw;
}
.box{
  width: 89vw;
  margin: auto;
  overflow: hidden;
  padding: 2.667vw;
  min-height:120vw ;
background: #FFFFFF;
border-radius: 2.667vw;
}
.content .headerinfo{
  min-height: 121px;
  display: flex;
  /* margin-top:65px; */
  padding: 18px 0 0 10px;
  margin-top:39px
}
.content .headerinfo img{
  display: inline-block;
  width: 91px;
  height: 91px;
}
.content .headerinfo h2{
  background-image: url(/static/img/baiotiti.png);
    background-repeat: no-repeat;
    background-size: contain;
   min-height: 92px;
    width: 465px;
    margin: auto;
    position: relative;
    top: 50px;
    font-size: 36px;
    text-align: center;
    line-height: 92px;
font-weight: bold;
color: #333333;
}
.compytitle{
    min-height: 91px;
    width: 450px;
    position: relative;
    left: 10px;
    border-radius: 5px;
    display: inline-block;
}
.compytitle h3{
    font-size: 24px;
  /* font-weight: bold; */
  color: #333333;
  letter-spacing: 4px;
}
.content .typecontent span{
  color: #333333;
    float: right;
    line-height: 44px;
    height: 41px;
    font-size: 16px;
}
.compytitle p{
  height: 22px;
    overflow: hidden;
    font-size: 21px;
    font-weight: 400;
    margin-top: 13px;
    color: #CDCCD8;
    letter-spacing: 3px;
    -webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
.codeinfo{
  margin-top: 18px;
  width: 94vw;
  height: 65px;
  /* background: rgba(21, 0, 125, 0.3); */
  line-height: 65px;
  font-size: 24px;
  color: #333333;
  border-radius: 5px;
}
.codeinfo img{
  margin-left: 1.067vw;
  margin-right: 1.6vw;
  position: relative;
    top: 3vw;
}
.detailInfo{
  margin-top:20px;
  width: 94vw;
  min-height: 255px;
  /* background: rgba(21, 0, 125, 0.3); */
  border-radius: 5px;
  /* padding: 12px 2vw 28px 2vw; */

}

.detailInfo td{
   border-bottom: 1px dashed #EDF0F6; 
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 10px;
  font-size: 21px;
  line-height: 33px;
}
.detailInfo tr td:nth-child(2n-1){
  font-size: 18px;
color: #999999;
  width: 179px;
}
.detailInfo tr td:nth-child(2n){
  width: 469px;
  font-size: 18px;
  color: #333333;
}
.content .typecontent h2{
    position: relative;
    font-size: 32px;
    line-height: 32px;
    color: #2E8EEB;
}
.content .typecontent span{
  color: #333333;
    float: right;
    line-height: 44px;
    height: 35px;
    position: relative;
    font-size: 16px;
    right: 0px;
    top: -33px;
}
.show .header{
  position: relative;
  width: 100vw;
  margin:0 auto;
height: auto;
background: #FFFFFF;
box-shadow: 0px 0.267vw 1.333vw 0px rgba(65,65,65,0.09);
}
.show .headerbox{
  position: relative;
  padding: 3.333vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerbox img{
  width:26.4vw;
}
.headerbox .back{
  width: 41.867vw;
  height: 5.6vw;
border: 0.133vw solid #2F8EEC;
}
.headerbox a{
  display: inline-block;
  width: 20.93vw;
height: 5.6vw;
font-size: 2.4vw;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 5.6vw;
text-align: center;
}
.headerbox a.light{
background: #2E8EEB;

color: #FFFFFF;
}
.result{
  position: relative;
  width: 100vw;
  height: 44.933vw;
  background-color: #FFFFFF;
}
.result h2{
  position: relative;
  padding:10.267vw 0 13.067vw;
height: 4.667vw;
font-size: 4.667vw;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 4.667vw;
text-align: center;
}
.result h2::after{
  position: absolute;
  content:'';
  left:47.467vw;
  bottom: 8.133vw;
width: 4.933vw;
height: 1.067vw;
background: #2E8EEB;
border-radius: 0.4vw;
}
.result div{
  position: relative;
  width: 81vw;
  padding-left: 12.667vw;
  margin: auto;
height: 12.8vw;
background: #FFEEED;
font-size: 3.2vw;
font-family: PingFang SC;
font-weight: 500;
color: #F24040;
line-height: 4.8vw;
display: flex;
justify-content: start;
align-items: center;
background-image: url(/static/img/img/reccet.png);
background-repeat: no-repeat;
background-size: 5.067vw 5.067vw;
background-position: 4.8vw center;
}
.perinfo{
  position: relative;
    font-size: 32px;
    line-height: 32px;
    color: #2E8EEB;
}
</style>